interface IUseScrollListElementIntoView {
    container: HTMLElement;
    target: HTMLElement;
    padding?: number;
}

export const useScrollListElementIntoView = (): ((params: IUseScrollListElementIntoView) => void) => {
    return ({container, target, padding = 10}: IUseScrollListElementIntoView): void => {
        const {offsetTop: targetOffsetTop, offsetHeight: targetOffsetHeight} = target;
        const {scrollTop: containerScrollTop, clientHeight: containerClientHeight} = container;

        const targetBottomEdge = targetOffsetTop + targetOffsetHeight;

        const targetTopHidden = targetOffsetTop <= containerScrollTop;
        const targetBottomHidden = targetBottomEdge >= containerScrollTop + containerClientHeight;

        const containerBottomEdge = containerScrollTop + containerClientHeight;

        // Skip container scroll if target is fully visible
        if (targetOffsetTop > containerScrollTop && targetOffsetTop + targetOffsetHeight < containerBottomEdge) {
            return;
        }

        if (targetTopHidden || targetBottomHidden) {
            container.scroll({
                top: targetTopHidden ? targetOffsetTop - padding : targetOffsetTop + padding,
                behavior: "smooth"
            });
        }
    };
};
interface IUseScrollListElementIntoView {
    container: HTMLElement;
    target: HTMLElement;
    padding?: number;
}

export const useScrollListElementIntoView = (): ((params: IUseScrollListElementIntoView) => void) => {
    return ({container, target, padding = 10}: IUseScrollListElementIntoView): void => {
        const {offsetTop: targetOffsetTop, offsetHeight: targetOffsetHeight} = target;
        const {scrollTop: containerScrollTop, clientHeight: containerClientHeight} = container;

        const targetBottomEdge = targetOffsetTop + targetOffsetHeight;

        const targetTopHidden = targetOffsetTop <= containerScrollTop;
        const targetBottomHidden = targetBottomEdge >= containerScrollTop + containerClientHeight;

        const containerBottomEdge = containerScrollTop + containerClientHeight;

        // Skip container scroll if target is fully visible
        if (targetOffsetTop > containerScrollTop && targetOffsetTop + targetOffsetHeight < containerBottomEdge) {
            return;
        }

        if (targetTopHidden || targetBottomHidden) {
            container.scroll({
                top: targetTopHidden ? targetOffsetTop - padding : targetOffsetTop + padding,
                behavior: "smooth"
            });
        }
    };
};
